import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { DwComponent, DwComponentType, DwContext, DwFormControl, DwFormFieldConfig } from '@devwareapps/devware-cap';
import { Subscription } from 'rxjs';

import { AppMetaDataLookups } from '../../../../meta-data/app-meta-data.service';
import { StudentRepositoryService } from '../../../students/services/student-repository.service';

@DwComponent({
  key: 'assignment-course-form-control',
  name: 'Assignment Course Form Control',
  componentType: DwComponentType.formControl,
  isGlobal: true
})
@Component({
  selector: 'app-assignment-course-form-control',
  template: `
    <dw-search-select-lookup
      [formControl]="control"
      [lookupId]="lookupId"
      [paramValues]="lookupParams"
      [showBlankOption]="true"
      blankOptionText="Select Course"
      placeholder="Select Course">
    </dw-search-select-lookup>
  `,
  styles: [':host { display: contents; }']
})
export class AssignmentCourseFormControlComponent implements DwFormControl, OnInit, OnDestroy {
  fieldDef: DwFormFieldConfig;
  formGroup: FormGroup;
  inputClass = 'form-control';
  @Input() context: DwContext;

  lookupId: number | string;
  lookupParams: number[] = [];

  private flightSchoolSubscription: Subscription;
  private studentSubscription: Subscription;

  constructor(
    private router: Router,
    private studentRepositoryService: StudentRepositoryService
  ) { }

  ngOnInit(): void {
    this.updateLookup();
    this.flightSchoolSubscription = this.formGroup.get('FlightSchoolId')?.valueChanges.subscribe(() => this.updateLookup());

    const userId = this.getManageUserAssignmentAddUserId();
    if (!userId) {
      return;
    }

    this.studentSubscription = this.studentRepositoryService.getStudentFromUserId(userId).subscribe(student => {
      if (!student?.StudentId) {
        return;
      }

      this.lookupId = AppMetaDataLookups.CourseBySchoolStudent;
      this.lookupParams = [this.getFlightSchoolId(), Number(student.StudentId)];
    });
  }

  ngOnDestroy(): void {
    this.flightSchoolSubscription?.unsubscribe();
    this.studentSubscription?.unsubscribe();
  }

  get control(): AbstractControl {
    return this.formGroup?.get(this.fieldDef?.attrName);
  }

  private updateLookup(): void {
    if (this.lookupId === AppMetaDataLookups.CourseBySchoolStudent) {
      this.lookupParams = [this.getFlightSchoolId(), this.lookupParams[1]];
      return;
    }

    this.lookupId = this.resolveDefaultLookupId();
    this.lookupParams = [this.getFlightSchoolId()];
  }

  private resolveDefaultLookupId(): number | string {
    const lookupOverride = this.fieldDef?.lookupConfig?.lookupIdOverride;

    return typeof lookupOverride === 'number' || typeof lookupOverride === 'string'
      ? lookupOverride
      : this.fieldDef?.attr?.MetaDataLookupId;
  }

  private getFlightSchoolId(): number {
    return Number(this.formGroup?.get('FlightSchoolId')?.value) || null;
  }

  private getManageUserAssignmentAddUserId(): number {
    const path = (this.router.url || '').split('?')[0].split('#')[0];
    const match = /^\/manage-users\/edit\/(\d+)\/assignments\/add\/?$/.exec(path);

    return match ? Number(match[1]) : null;
  }
}
